import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAutomobileCatalogBootstrap } from '../../contexts/AutomobileCatalogContext';

/** /otomobil rotalarında katalog yüklemesini başlatır */
const AutomobileCatalogLayout: React.FC = () => {
  useAutomobileCatalogBootstrap();
  return <Outlet />;
};

export default AutomobileCatalogLayout;
